"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlFloatBuffer = void 0;
const gl_buffer_1 = require("../buffers/gl-buffer");
/**
 * @public
 * Float32 {@link GlBuffer}.
 */
class GlFloatBuffer extends gl_buffer_1.GlBuffer {
    constructor(data) {
        super(data, Float32Array);
    }
}
exports.GlFloatBuffer = GlFloatBuffer;
//# sourceMappingURL=gl-float-buffer.js.map